<template>
  <div class="table-wrapper">
    <table 
      class="table has-smallest-font mt-3"
      :class="{ 'is-fullwidth': isFullwidth }">
      
      <thead>
        <tr class="has-text-centered">
          <th
            v-for="(header, i) in headers"
            :key="i">
            {{ header.label }}
            <span 
              v-if="header.label == 'Area' && hasFootnotes"
              class="has-text-weight-normal">
              [1]
            </span>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr>
          <td class="category has-text-weight-bold" rowspan="3">
            Material
          </td>
          <td class="description">
            <div class="has-text-weight-bold">
              SolaRail Glass
            </div>
            <!-- <div class="help">
              Tempered Laminated Glass, Grey, 20% Transparent
            </div> -->
          </td>
          <td class="area has-text-weight-bold has-text-right">
            {{ linearFt | commasep(0) }}
          </td>
          <td class="unit has-text-weight-bold">
            L. Ft
          </td>
        </tr>

        <tr>
          <td class="description">
            <div class="has-text-weight-bold">
              SolaRail Solar Cell
            </div>
            <div class="help">
              Thin film solar cell sandwiched between 2 glass panes.
            </div>
          </td>
          <td class="area has-text-weight-bold has-text-right">
            {{ linearFt * coverage | commasep(0) }}
          </td>
          <td class="unit has-text-weight-bold">
            L. Ft
          </td>
        </tr>

        <tr>
          <td class="description">
            <div class="has-text-weight-bold">
              Frame
            </div>
            <div class="help">
              Small base mount. Material Aluminum. Drawing included in the estimation
            </div>
          </td>
          <td class="area has-text-weight-bold has-text-right">
            Included
          </td>
          <td class="unit has-text-weight-bold">
          </td>
        </tr>

        <tr>
          <td class="category has-text-weight-bold" rowspan="1">
            Electricity
          </td>
          <td class="description">
            <div class="has-text-weight-bold">
              Approx. Energy Yield
            </div>
            <div class="help">
              The electricity generated by the system.
            </div>
          </td>
          <td class="area has-text-weight-bold has-text-right">
            {{ railMpa.system_size }}
          </td>
          <td class="unit has-text-weight-bold">
            kW
          </td>
        </tr>

        <!-- <tr>
          <td class="description">
            <div class="has-text-weight-bold">
              Solar Cell Coverage Rate
            </div>
            <div class="help">
              The average coverage of panels across all elevation
            </div>
          </td>
          <td class="area has-text-weight-bold has-text-right">
            {{ coverage * 100 | round(0) }}
          </td>
          <td class="unit has-text-weight-bold">
            %
          </td>
        </tr> -->

        <tr>
          <td class="category has-text-weight-bold" rowspan="3">
            Service
          </td>
          <td class="description">
            <div class="has-text-weight-bold">
              Shop Drawings
            </div>
            <div class="help">
              Panel Layout & Engineering
            </div>
          </td>
          <td class="area has-text-weight-bold">
          </td>
          <td class="unit has-text-weight-bold">
            Set
          </td>
        </tr>

        <tr>
          <td class="description">
            <div class="has-text-weight-bold">
              Packaging and Delivery
            </div>
          </td>
          <td class="area has-text-weight-bold has-text-right">
            {{ runs }}
          </td>
          <td class="unit has-text-weight-bold">
            Runs
          </td>
        </tr>

        <tr>
          <td class="description">
            <div class="has-text-weight-bold">
              Installation and Maintenance 
              <span v-if="hasFootnotes" class="has-text-weight-normal">[2]</span>
            </div>
          </td>
          <td class="area has-text-weight-bold has-text-right">
            Included
          </td>
          <td class="unit has-text-weight-bold">
            Crew
          </td>
        </tr>
      </tbody>

      <tfoot class="has-text-weight-bold">
        <tr>
          <td class="category" :rowspan="hasMpaPrice + +hasDpaPrice">
            Pricing (CAD$)
          </td>

          <template v-if="hasMpaPrice">
            <td class="description">
              <span v-if="hasMpaPrice && hasDpaPrice">
                OPTION 1: MPA
              </span> 
              <span v-else>Total MPA Price</span> 
              <span class="has-text-weight-normal"> (Excl. HST)</span>
            </td>
            <td class="area">
              {{ railMpa.price | currency(0) }}
            </td>
            <td class="unit"></td>
          </template>

          <template v-if="!hasMpaPrice && hasDpaPrice">
            <td class="description">
              Total DPA Price
              <span class="has-text-weight-normal"> (Excl. HST)</span>
            </td>
            <td class="area">
              {{ railDpa.price | currency(0) }}
            </td>
            <td class="unit"></td>
          </template>
        </tr>

        <tr v-if="hasMpaPrice && hasDpaPrice">
          <td class="description">
            <span v-if="hasMpaPrice && hasDpaPrice">
              OPTION 2: DPA
            </span> 
            <span v-else>Total DPA Price</span> 
            <span class="has-text-weight-normal"> (Excl. HST)</span>
          </td>
          <td class="area">
            {{ railDpa.price | currency(0) }}
          </td>
          <td class="unit"></td>
        </tr>

        <!-- 
        <tr >
          <td class="description">
            Mitrex credit 
            <span class="has-text-weight-normal">
              [2]
            </span>
          </td>
          <td class="area">
            - {{ rail.what_should_be_paid - rail.price | currency(0) }}
          </td>
          <td class="unit"></td>
        </tr> -->

        <!-- <tr>
          <td class="description">
            HST 
          </td>
          <td class="area">
            {{ rail.price * 0.13 | currency(0) }}
          </td>
          <td class="unit"></td>
        </tr>

        <tr>
          <td class="description">
            Total cost including HST 
          </td>
          <td class="area">
            {{ rail.price * 1.13 | currency(0) }}
          </td>
          <td class="unit"></td>
        </tr> -->
      </tfoot>
    </table>

    <div v-if="hasFootnotes" class="help">
      <div>
        [1] Area is including material waste.
      </div>
      <div>
        [2] Maintenance is included for the period of the energy contract.
      </div>
    </div>
    <!-- <div class="help">
      [2] Credit for the solar technology to lower up-front costs.
    </div>   -->
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    estimation: {
      type: Object
    },
    railingType: {
      type: String,
      default: '1100 1400'
    },
    hasMpaPrice: {
      type: Boolean,
      default: true
    },
    hasDpaPrice: {
      type: Boolean,
      default: true
    },
    isFullwidth: {
      type: Boolean,
      default: false
    },
    hasFootnotes: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      headers: [
        { label: 'Item' },
        { label: 'Description' },
        { label: 'Area' },
        { label: 'Unit' }
      ]
    }
  },
  computed: {
    summaryObjectMpa({ estimation }) {
      return estimation.estimation_summary
    },
    summaryObjectDpa({ estimation }) {
      return estimation.estimation_summary_dpa
    },
    railMpa({ summaryObjectMpa, railingType }) {
      return summaryObjectMpa.summary.filter(
        d => d.pricing_summary.includes('rail') &&
          d.pricing_summary.replaceAll(
            '_', ' '
          ).includes(railingType)
      )[0];
    },
    railDpa({ summaryObjectDpa, railingType }) {
      return summaryObjectDpa.summary.filter(
        d => d.pricing_summary.includes('rail') &&
          d.pricing_summary.replaceAll(
            '_', ' '
          ).includes(railingType)
      )[0];
    },
    coverage({ summaryObjectMpa, railingType }) {
      let railSummary = [];
      Object.keys(summaryObjectMpa).forEach(key => {
        if (key.replaceAll('_', ' ').includes(railingType)) {
          railSummary = summaryObjectMpa[key];
        }
      })

      return railSummary.map(d => d.sum_solar_sqft).reduce(
        (a, b) => a + parseFloat(b) || 0, 0
      ) / railSummary.map(d => d.sum_area_sqft).reduce(
        (a, b) => a + parseFloat(b) || 0, 0
      )
    },
    linearFt({ summaryObjectMpa, railingType }) {
      var railingLinearFt;
      Object.keys(summaryObjectMpa).forEach(key => {
        if (key.replaceAll('_', ' ').includes(railingType)) {
          railingLinearFt = summaryObjectMpa[key].map(
            d => d.sum_linear_ft
          ).reduce((a, b) => a + +b, 0);
        }
      })

      return railingLinearFt;
    },
    runs({ value, estimation }) {
      if (estimation.no_of_runs > 0) {
        return estimation.no_of_runs
      } else if (value) {
        return value
      } else {
        return 'included'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/table.scss';
@import '@/styles/detailed-pricing.scss';
</style>